import { IDataSource } from '@commenda/types/src/datasource/interface';
import { TGetDataSourceListParams } from '@commenda/types/src/datasource/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

export function useDatasources(params?: TGetDataSourceListParams) {
  const queryParams = new URLSearchParams();
  if (params?.type) queryParams.append('type', params.type);

  const url = `datasource/list${queryParams.toString()}`;

  return useSWR<{ data: IDataSource[]; count: number }>(
    url,
    SWRFetcher({
      method: 'GET',
    })
  );
}
